export default "__VITE_ASSET__BLuZIgRp__"